<template>
  <div class="global-popup">
    <div class="box global-popup-inner global-popup-inner-delete df fdc" v-on:click="stopProp($event)">
      <div class="popup-top df">
        <img src="/images/Redo-Button.png" alt="">
        <div class="">
          <p class="popup-title gg-font">Share Project</p>
          <p class="popup-text gg-font">Invite people to this project via specified email address or public link</p>
        </div>
      </div>
      <div class="popup-bottom">
        <p class="popup-text gg-font popup-sub-heading">
          Enter the email addresses of the people you would like to share this project with
        </p>
        <input v-model="shareEmails" class="input-landing w100p">
        <p class="popup-text gg-font popup-sub-heading">
          Choose how they will participate in your project...
        </p>
        <div class="radioGroup">
          <div>
            <input v-model="role" type="radio" id="vendor" name="participate" value="vendor">
            <label for="vendor">As a Vendor</label>
          </div>
          <div>
            <input v-model="role" type="radio" id="collaborator" name="participate" value="collaborator">
            <label for="collaborator">As a Collaborator</label>
          </div>
          <div>
            <input v-model="role" type="radio" id="customer" name="participate" value="customer">
            <label for="customer">As a Customer</label>
          </div>
        </div>
        <p class="popup-text gg-font popup-sub-heading">
          Invite to Project with link:
        </p>
        <div class="df">
          <input v-model="copyLink" class="input-landing w100p" disabled>
          <button class="link-button" @click="copyLinkClicked()">Copy Link</button>
        </div>

        <span class="buttons df jcfe">
          <button class="popup-reject-button gg-font" @click="closePopup()">
            Cancel
          </button>
          <button class="popup-accept-button gg-font" v-on:click="doShare()">
            Share
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require('axios')
import { mapGetters } from 'vuex'

export default {
  name: 'PopupShare',
  data () {
    return {
      comments: '',
      shareEmails: '',
      shareType: 'view',
      role: 'vendor',
      token: ''
    }
  },
  props: ['closePopup'],
  components: {
  },
  methods: {
    copyLinkClicked() {
      navigator.clipboard.writeText(this.copyLink)
    },
    stopProp (e) {
      e.stopPropagation()
    },
    async doShare () {
      if (this.validateShareProject()) {
        var data = {
          projectid: this.$route.params.projectid,
          projectName:  this.currentProjectName,
          userName: this.userData.fullName,
          emails: this.validateShareProject(),
          message: this.comments,
          url: window.location,
          role: this.role
        }
        await this.$store.dispatch('doShare', data)
        this.closePopup()
      }
    },
    validateShareProject () {
      var emails = this.shareEmails.split(',')
      emails = emails.map(v => v.trim())
      emails = emails.filter(v => v !== '')
      emails = emails.filter(v => this.validateEmail(v))

      if (emails.length > 0) {
        return emails
      }
      return false
    },
    validateEmail(email) {
      console.log('validating this email', email)
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    deleteProject (id) {
        this.$store.dispatch('deleteProject', {
            projectID: id,
            userID: this.$store.getters.uid
        }).then(() => {
          this.closePopup()
        })
    },
  },
  computed: {
    ...mapGetters([
      'userData',
      'currentProjectName'
    ]),
    copyLink() {
      return window.location + `?token=${this.token}`;
    }
  },
  watch: {
  },
  mounted () {
  },
  created () {
    console.log('==>', this.$route);
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = 32; i > 0; --i) {
      this.token += chars[Math.floor(Math.random() * chars.length)];
    }
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetails
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
        case 'REMOVE_PROJECT':
          setTimeout(() => {
            this.myProjectDetailsList = this.$store.getters.myProjectListWithDetails
          }, 100)
          break
      }
    })
    this.$store.watch(() => {
      return this.$store.getters.myProjectListWithDetailsFull
    }, () => {
      // console.log('---->')
    })
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'ADD_PROJECT_FULL':
          setTimeout(() => {
            this.myProjectDetailsListFull = this.$store.getters.myProjectListWithDetailsFull
          }, 100)
          break
      }
    })
  }
}
</script>

<style scoped lang="scss">
  .radioGroup {
    display: flex;
    justify-content: space-between;
  }
  h3 {
    font-size: 24px;
    font-weight: 300;
    padding-bottom: 30px;
    padding-top: 50px;
    text-align: center;
  }
  .wrapper {
    width: 100%;
    max-width: 1280px;
    min-height: 100vh;
    /*overflow-x: hidden;*/
  }


  //
  // Global Popup
  //
  .global-popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.7);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  //
  // Global Popup Inner
  //
  .global-popup-inner {
    width: 100%;
    position: fixed;

    .popup-top {
      background-color: #F5F5F5;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      padding: 24px 44px;

      img {
        object-fit: contain;
      }

      & > div {
        margin-left: 16px;
      }
    }
    .popup-bottom {
      padding: 20px 44px 24px;
    }
    .popup-title {
      font-weight: 500;
      color: #313131;
      font-size: 24px;
    }
    .popup-text {
      color: #313131;
      font-size: 16px;
    }
    .popup-sub-heading {
      font-weight: 500;
      padding-bottom: 6px;
      margin-top: 20px;
    }
    .popup-point {
      padding-left: 20px;

      &::before {
        content: '•';
        margin-right: 6px;
      }
    }
    .popup-accept-button {
      min-width: 80px;
      padding: 10px 12px;
      border-radius: 5px;
      background-color: #5558FF;
      border: none;
      color: white;
      font-weight: 500;
      font-size: 16px;
      margin-left: 16px;
      cursor: pointer;

      &:hover {
        background-color: darken(#5558FF, 5%);
      }
    }
    .popup-reject-button {
      min-width: 80px;
      padding: 10px 12px;
      border-radius: 5px;
      background-color: #F5F5F5;
      border: none;
      color: #313131;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;

      &:hover {
        background-color: darken(#F5F5F5, 5%);
      }
    }
    .buttons {
      margin-top: 24px;
      padding-top: 8.5px;
      padding-bottom: 8.5px;
    }

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      width: auto;
      margin-left: 20px;
      margin-right: 20px;

      // popup title
      .popup-title {
        font-size: 16px;
      }

      // popup text
      .popup-text {
        font-size: 12px;
      }

      // button
      button {
        font-size: 12px !important;
      }
    }
  }


  //
  // Global Popup Inner Delete
  //
  .global-popup-inner-delete {
    max-width: 600px;
  }


  .input-wrapper {
    & > p {
      padding-bottom: 5px;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.02em;

      & > span {
        margin-left: 4px;
        font-size: 90%;
        font-weight: 300;
        color: #888888;
      }
    }
  }
  .full-blue {
    margin-top: 18px;
    margin-bottom: 6px;
  }
  .share-select, .share-selected {
    min-width: 120px;
    padding: 20px;
    margin-left: 12px;

    &:first-child {
      margin-left: 0;
    }
  }
  .share-select {
    color: #666;
    background-color: #eee;
    box-shadow: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }
  .share-selected {
    color: #5558FF;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
  }
  .comments {
    margin-bottom: 20px;
    margin-top: 20px;
    border: none;
    padding: 20px;
    background-color: #eee;
    box-shadow: none;
    font-size: 16px;
    width: 100%;
  }
  .button-form {
    margin-bottom: 20px;
  }
  .cancel {
    position: absolute;
    top: 0;
    left: 30px;
  }
  .get-link {
    position: absolute;
    top: 0;
    right: 30px;
  }
  .ok-button {
    margin-top: 20px;
  }
  .link-button {
      min-width: 100px;
      padding: 10px 12px;
      border-radius: 5px;
      background-color: #5558FF;
      border: none;
      color: white;
      font-weight: 600;
      font-size: 12px;
      cursor: pointer;
      &:hover {
        background-color: darken(#5558FF, 5%);
      }
    }


</style>
